// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as NotificationsActions } from '../notifications/duck';
import { actions as SavedAddressesActions } from '../saved-addresses/duck';
import { actions as PayoutsActions } from '../payouts/duck';
import { actions as PaymentsActions } from '../payments/duck';
import Preferences from '../../preferences/components/Preferences';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingNotificationsSettings: state.preferences.notifications.isFetchingNotificationsSettings,
    notificationsSettings: state.preferences.notifications.notificationsSettings,
    fetchNotificationsSettingsError: state.preferences.notifications.fetchNotificationsSettingsError,
    isFetchingAddresses: state.preferences.savedAddresses.isFetchingAddresses,
    addresses: state.preferences.savedAddresses.addresses,
    fetchAddressesError: state.preferences.savedAddresses.fetchAddressesError,
    isFetchingPayouts: state.preferences.payouts.isFetchingPayouts,
    payouts: state.preferences.payouts.payouts,
    fetchPayoutsError: state.preferences.payouts.fetchPayoutsError,
    isFetchingPayments: state.preferences.payments.isFetchingPayments,
    payments: state.preferences.payments.payments,
    fetchPaymentsError: state.preferences.payments.fetchPaymentsError,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    goToEditProfile: (route) => push(route),
    ...NotificationsActions, ...SavedAddressesActions, ...PayoutsActions, ...PaymentsActions
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);



// WEBPACK FOOTER //
// ./src/modules/preferences/containers/PreferencesContainer.js